import React, { useEffect, useState } from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Slider from "react-slick";
import "./galleryZoom.scss";


const GalleryZoom = (props:ReferenciaContenido) => {
    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState(0);


    const goToNext = () => {
        if (sliderIndex < slider.props.children.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const CarouselGeneral = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 5000,   
        variableWidth: true,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        },
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: true,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: true,
                },
            },
        ],
    };


    const isActiveBack = () => sliderIndex > 0;
    const isActiveNext = () => sliderIndex < slider?.props.children.length - 1;

    return(
        <>
            {(props.listaImagenes && props.listaImagenes.length > 0) ? (
                <div className="o-galleryZoom">
                    <div className="o-galleryZoom__contentTop">
                        <div className="o-galleryZoom__contentTop__title">
                            <h2>Galería</h2>
                        </div>
                        <div className="arrows-slider">
                            <span
                                className={`arrow icon-chevron-left ${
                                    isActiveBack() ? "active" : ""
                                }`}
                                onClick={goToBack}
                            ></span>
                            <span
                                className={`arrow icon-chevron-right  ${
                                    isActiveNext() ? "active" : ""
                                }`}
                                onClick={goToNext}
                            ></span>
                        </div>
                    </div>
                    <div className="container_carrusel">
                        <div className={`o-galleryZoom__container`}>
                            <Slider
                                ref={(c) => {
                                    setSlider(c);
                                }}
                                {...CarouselGeneral}
                            >
                                {props.listaImagenes.length > 0 && props.listaImagenes.map(
                                    (item: any, index) => (
                                        <>
                                            {
                                                item.fields ? (
                                                    <div className={`o-galleryZoom__containerImage `} key={index}>
                                                        <img
                                                            className={`o-galleryZoom__containerImage_${item.fields.title}`}
                                                            src={item.fields.file.url}
                                                            alt={item.fields.title} 
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className={`o-galleryZoom__containerImage `} key={index}>
                                                        <img
                                                            className={`o-galleryZoom__containerImage_${item.title}`}
                                                            src={item.file.url}
                                                            alt={item.title} 
                                                        />
                                                    </div>
                                                )
                                            }

                                        </>
                                    )
                                )}
                            </Slider>
                        </div>
                    </div>
                </div>
            ) : ""}
        </>
    );
}

export default GalleryZoom;